import { apiFetch } from "./client";
import type { AvailableSlots, Booking, ChangeRequest } from "./types";

export interface AvailabilityQuery {
  load_id: number;
  bay_id: number;
  day: string;
}

export async function availableSlots(query: AvailabilityQuery): Promise<AvailableSlots> {
  const qs = new URLSearchParams({
    load_id: String(query.load_id),
    bay_id: String(query.bay_id),
    day: query.day,
  });
  return apiFetch<AvailableSlots>(`/slots/available?${qs.toString()}`);
}

export interface BookingCreate {
  load_id: number;
  bay_id: number;
  start_utc: string;
  end_utc: string;
}

export async function createBooking(data: BookingCreate): Promise<Booking> {
  return apiFetch<Booking>("/slots/bookings", { method: "POST", body: JSON.stringify(data) });
}

export async function cancelBooking(id: number): Promise<Booking> {
  return apiFetch<Booking>(`/slots/bookings/${id}`, { method: "DELETE" });
}

export interface ChangeRequestCreate {
  load_id: number;
  bay_id: number;
  start_utc: string;
  end_utc: string;
  expires_at: string;
}

export async function createChangeRequest(data: ChangeRequestCreate): Promise<ChangeRequest> {
  return apiFetch<ChangeRequest>("/slots/change-requests", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function getPendingApprovalCount(): Promise<{ count: number }> {
  return apiFetch<{ count: number }>("/slots/approvals/pending-count");
}

export async function listChangeRequests(status?: string): Promise<ChangeRequest[]> {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  return apiFetch<ChangeRequest[]>(`/slots/change-requests${qs}`);
}

export async function approveChangeRequest(id: number): Promise<ChangeRequest> {
  return apiFetch<ChangeRequest>(`/slots/change-requests/${id}/approve`, { method: "POST" });
}

export async function rejectChangeRequest(id: number): Promise<ChangeRequest> {
  return apiFetch<ChangeRequest>(`/slots/change-requests/${id}/reject`, { method: "POST" });
}
